import { useState } from "react";
import { faqItems } from "../../../mocks/trendData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-10 md:py-14">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="container-x grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="section-kicker">常见问题</span>
          <h2 className="mt-3 font-heading text-xl font-black leading-snug tracking-tight text-foreground-950 md:text-3xl">
            关于追踪，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            没找到答案？欢迎在页面底部留下问题或通过线索表单联系我们，我们会尽快补充说明。
          </p>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-100">
            {faqItems.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <h3 className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</h3>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-4 pb-4 pl-4 text-sm leading-relaxed text-foreground-600 md:px-5 md:pl-5">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}